export default [
    {
        name: "timer",
        path: "/timer",
        component: () => import("@/modules/Timer"),
    },
];
